import React, {useState, useEffect} from 'react';
import { SurveyForm } from './SurveyForm';
import "./Styles/SurveyContainer.css";
import axios from 'axios';

export const SurveyContainer = ({history, passPortal, postBalance, test}) => {
    const {DeviceID, ap, campaign, survey_ids, band, search} = history.location;
    const [loading, setLoading] = useState(true);
    const [survey, setSurvey] = useState();
 /*    const [error, setError] = useState(null);
    const [hasCuopon, setHasCuopon] = useState(() => {
        return campaign.CampaignCouponURL ? true: false;
    });
 */
    useEffect(() => {
        _fethSurvey();
    }, []);

    const _fethSurvey = async() => {
        try {
            const res = await axios.get("/surveys", {
                params: {survey_id: campaign.survey_id}
            });
            let surveysQuestions = [];
            for (const question of res.data.questions) {
              
                let answer = {
                    survey_question_id: question.id,
                    store_id: ap.ap_locationid,
                    answer: "",
                    user_mac_address: DeviceID
                };

                let newQuestion = {
                    ...question,
                    posible_answer: question.posible_answer ? question.posible_answer.split(",") : [],
                    answer
                };
                surveysQuestions.push(newQuestion);
            };
            setSurvey({
                ...res.data,
                questions: surveysQuestions
            });
            setLoading(false);
        } catch (error) {
            setLoading(false);
        }
    }
    
    const postAnswers = async () => {
        try {
            let answers = survey.questions.map(v => {
                return {
                    store_id: ap.ap_locationid,
                    answer: v.answer,
                    survey_question_id: v.id,
                    user_mac_address: DeviceID,
                    survey_id: survey.id
            }});
            let fields = {
                user_mac_address: DeviceID,
                store_id: ap.ap_locationid,
                survey_id: survey.id,
                answers
            };
            if(!test) {
                const {data} = await axios.post("/surveys", fields);
                await postBalance(campaign, "surveys", data);
            }
            setError(null);
            if(campaign.CampaignCouponURL) {
               history.history.push({
                    pathname: "/content",
                    campaign: campaign,
                    DeviceID: DeviceID,
                    ap,
                    band,
                    survey_ids,
                    surveyAnsw:"answered",
                    search
              });
            } else {
                passPortal(ap, campaign, DeviceID);
            }
            return;
        } catch (error) {
            setError("Ocurrio un error, intenrelo mas tarde");
            return;
        }
    }

    const handlerChange = (question, value) => {
        let q = survey.questions.find(v => v.id === question.id);
        q.answer = value;
        setSurvey({...survey});
    }

    return(
        <div className="SurveyContainer animated fadeIn">
            <div className="SurveyHeader">
                <h4>{survey && survey.survey_name}</h4>
                <small>{survey && survey.description}</small>
            </div>
            <div>
                {loading ? <div>...</div> : 
                <SurveyForm 
                    questions={survey ? survey.questions : []} 
                    handlerChange={(question, value) => handlerChange(question, value)}
                    submitAnswers={() => postAnswers()}
                    /> 
                }
            </div>
        </div>
    )

}